import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class CyclistService {
  private apiURL: string = '';
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getCyclists(partnerID: any, page, limit) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Cyclists?Page=${page}&Limit=${limit}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclistsV2(partnerID: any, page, limit, search, type = null) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/${partnerID}/Search/Cyclists?Page=${page}&Limit=${limit}&Search=${encodeURIComponent(search)}${type != null ? "&Type=" + type : ""}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclistsOnPOS(partnerID: any, type, search) {
    var headers = this.helpersService.getPOSApiHeaders(
      this.appConfig.getPOSEnvironment().key,
    );
    return this.http
      .get(
        this.appConfig.getPOSEnvironment().url +
        `/${partnerID}/customers/search?type=${type}&value=${search}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  saveCyclist(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Cyclist/', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error) => {
          return throwError(
            this.translate.instant('messages.error_saving_user'),
          );
        }),
      );
  }

  linkCyclists(partnerID, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(this.env.url + `/store/${partnerID}/customers/link?code=${this.env.key}`, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveCyclistV2(data: any, partnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + `/api/Cyclist/${partnerID}`, data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res) => {
          this.errorHandler.showError(res,
            "Failed to update user details");

          return throwError(
            this.translate.instant('messages.error_saving_user'),
          );
        }),
      );
  }

  saveCyclistV3(data: any, partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(this.env.url + `/store/${partnerID}/customers?code=${this.env.key}`, data, headers)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res) => {
          this.errorHandler.showError(res,
            "Failed to update user details");

          return throwError(
            this.translate.instant('messages.error_saving_user'),
          );
        }),
      );
  }

  updateCyclist(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Cyclist', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          return throwError(error);
        }),
      );
  }

  unlinkCyclist(data: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(this.apiURL + '/api/Cyclist/Remove', data, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(
            this.translate.instant('messages.error_saving_user'),
          );
        }),
      );
  }

  saveImage(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Athlete/Profile/Pictures?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCyclist(email: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = { Email: email };
    return this.http
      .post(this.apiURL + '/api/Cyclist/search', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchUser(email: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = { Email: email };
    return this.http
      .post(this.apiURL + '/api/Cyclist/DoesUserExist', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }


  getCyclistById(cyclistId: number) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/api/Cyclist/' + cyclistId, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCyclistByIdForPrintSlip(cyclistId, partnerId) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + `/api/Cyclist/PrintSlip/${cyclistId}/${partnerId}`, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclist(partnerId: number, search: string) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailValid = re.test(String(search).toLowerCase());

    var pe = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    let phoneNumberValid = pe.test(String(search).toLowerCase());

    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      Surname: '',
      Name: '',
      Email: '',
      PhoneNumber: '',
      PartnerID: emailValid || phoneNumberValid ? 0 : partnerId,
      PartnerRating: 0,
      SearchAllFields: search,
      IsOnStrava: false,
    };
    return this.http
      .post(this.apiURL + '/api/Cyclist/search', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclistByEmail(partnerId: number, search: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      Surname: '',
      Name: '',
      Email: search,
      PhoneNumber: '',
      PartnerID: partnerId,
      PartnerRating: 0,
      SearchAllFields: '',
      IsOnStrava: false,
    };
    return this.http
      .post(this.apiURL + '/api/Cyclist/search', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclistByPhoneNumber(partnerId: number, search: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      Search: search,
      PartnerID: partnerId,
    };
    return this.http
      .post(this.apiURL + `/api/Cyclist/searchPhone`, body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  searchCyclistByPhoneFuzzy(partnerId: number, search: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      Surname: '',
      Name: '',
      Email: '',
      PhoneNumber: '%' + search.slice(-9),
      PartnerID: partnerId,
      PartnerRating: 0,
      SearchAllFields: '',
      IsOnStrava: false,
    };
    return this.http
      .post(this.apiURL + '/api/Cyclist/search', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclistBySurname(partnerId: number, search: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      Surname: search,
      Name: '',
      Email: '',
      PhoneNumber: '',
      PartnerID: partnerId,
      PartnerRating: 0,
      SearchAllFields: '',
      IsOnStrava: false,
    };
    return this.http
      .post(this.apiURL + '/api/Cyclist/search', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  searchCyclistByName(partnerId: number, search: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    let body = {
      Surname: '',
      Name: search,
      Email: '',
      PhoneNumber: '',
      PartnerID: partnerId,
      PartnerRating: 0,
      SearchAllFields: '',
      IsOnStrava: false,
    };
    return this.http
      .post(this.apiURL + '/api/Cyclist/search', body, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getBikesForCyclist(cyclistId: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(this.apiURL + '/api/Cyclist/' + cyclistId + '/bikes', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getBikesForCyclistV2(cyclistId: string, partnerType = 1, partnerID = 0) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/Athlete/${cyclistId}/Bikes?PartnerType=${partnerType}&PartnerID=${partnerID}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getBikesForCyclistPaged(cyclistId, partnerType = 1, partnerID = 0, page = 0, limit = 10, search = '') {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/Bikeshop/Athlete/${cyclistId}/Bikes/Paged?PartnerType=${partnerType}&PartnerID=${partnerID}&Page=${page}&Limit=${limit}&Search=${encodeURIComponent(search)}&code=${this.env.key}`,
        headers,
      )   
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getActiveBikesForCyclist(cyclistId: string, partnerType = 1) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/Cyclist/' +
        cyclistId +
        '/activebikes/partnertype/' +
        partnerType,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getActiveBikesForCyclistAndPartner(cyclistId: string, partnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL +
        '/api/Cyclist/' +
        cyclistId +
        '/activebikes/partner/' +
        partnerID,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

    getActiveItemsForCustomerAndPartner(cyclistId: string, partnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .get(
        this.apiURL + '/api/Customer/' + cyclistId + '/ActiveItems/Partner/' + partnerID,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  sendMessage(body: any) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + '/api/Cyclist/SendPushNotification',
        body,
        requestOptions,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateRoles(id, userRoles, partnerID) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();
    return this.http
      .post(
        this.apiURL + `/api/${partnerID}/Cyclist/${id}/UpdateRoles`,
        userRoles,
        requestOptions,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getFittingInfo(cyclistId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + `/Fittings/UserInfo/${cyclistId}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateFittingInfo(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Fittings/UserInfo/Update?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  mergeCyclist(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/cyclists/merge?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        }),
      );
  }

  sendWorkshopMessage(body: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/Workshop/Message?code=${this.env.key}`, body,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  saveCustomerAddresses(partnerID: string, customerID: string, addressDetails: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
        `/partner/${partnerID}/customers/${customerID}/addresses?code=${this.env.key}`, addressDetails,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateCustomerAddresses(partnerID: string, customerID: string, addressDetails: any, addressId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/partner/${partnerID}/customers/${customerID}/addresses/${addressId}?code=${this.env.key}`, addressDetails,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateCustomerAddressesDefault(partnerID: string, customerID: string, addressDetails: any, addressId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url +
        `/partner/${partnerID}/customers/${customerID}/addresses/${addressId}/Default?code=${this.env.key}`, addressDetails,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getCustomerAddresses(partnerID: string, customerID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
        `/partner/${partnerID}/customers/${customerID}/addresses?code=${this.env.key}`, 
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  deleteCustomerAddresses(partnerID: string, customerID: string, addressID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
        `/partner/${partnerID}/customers/${customerID}/addresses/${addressID}?code=${this.env.key}`, 
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  // Optional: More specific phone validation
  public isValidPhoneNumber(phone: string): boolean {
    if(!phone || phone.trim() === '') {
      return false; // Empty or undefined phone number is invalid 
    }
    // Remove all non-digit characters except +
    const cleanPhone = phone.replace(/[^\d\+]/g, '');

    // Check various phone formats
    const patterns = [
      /^\+?1?[2-9]\d{2}[2-9]\d{2}\d{4}$/, // US format
      /^\+?[1-9]\d{1,14}$/, // International format
      /^\d{10}$/, // Simple 10 digit
      /^\d{11}$/, // 11 digit with country code
    ];

    return patterns.some(pattern => pattern.test(cleanPhone));
  }

  // Optional: Enhanced email validation
  public isValidEmail(email: string): boolean {
    if(!email || email.trim() === '') {
      return false; // Empty or undefined phone number is invalid 
    }
    //const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;
    return emailRegex.test(email.trim());
  }
}
